import axios from './axios'

export const sendSupportEmail = params =>
  axios.postJson('/jobs/send_mail', params)

export const downloadCSV = (export_type) => axios.get(`jobs/export/client-data?export_type=${export_type}`)
